// @flow

import * as React from "react";

import "./NotFound.css";

const NotFound = () => <div className="NotFound">Page not found.</div>;

export default NotFound;
